import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

interface IWarningIconProps {
  width?: number;
  height?: number;
  color?: string;
}

function WarningIcon(props: IWarningIconProps) {
  return (
    <Svg
      width={props.width ?? 79}
      height={props.height ?? 78}
      viewBox="0 0 79 78"
      fill="none"
    >
      <Path
        d="M39.5 11a4.99 4.99 0 014.313 2.475l27 46a4.99 4.99 0 01.025 5.012A5.009 5.009 0 0166.5 67h-54a5.009 5.009 0 01-4.337-2.513 5.02 5.02 0 01.025-5.012l27-46A4.99 4.99 0 0139.5 11zm0 16c-1.663 0-3 1.337-3 3v14c0 1.663 1.337 3 3 3s3-1.337 3-3V30c0-1.663-1.337-3-3-3zm4 28a4 4 0 10-8 0 4 4 0 008 0z"
        fill={props.color ?? '#FFAB1E'}
      />
    </Svg>
  );
}

export default WarningIcon;
